import { Tooltip } from "@altimateai/lego";
import { formatNumber } from "./format";
import { useAppState } from "@/modules/app";

interface Props {
  value?: number;
  options?: Intl.NumberFormatOptions;
  noTooltip?: boolean;
  showNaForNull?: boolean;
}

const NumberFormatter = ({ value, options, noTooltip, showNaForNull }: Props) => {
  const { currencySymbol } = useAppState();
  if (value === undefined || value === null) {
    if (showNaForNull) return "N/A";
    return null;
  }
  return (
    <Tooltip title={noTooltip ? undefined : `${currencySymbol}${value.toFixed(2)}`}>
      <span>{formatNumber(value, options)}</span>
    </Tooltip>
  );
};

export default NumberFormatter;
